"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EtherERC721Client = void 0;
const typechain_1 = require("../../../contracts/typechain");
class EtherERC721Client {
    constructor() {
        this._waitConfirmations = 5;
    }
    async connectProvider(address, provider) {
        this.provider = provider;
        this.erc721 = typechain_1.ERC721Upgradeable__factory.connect(address, this.provider);
        return this;
    }
    connectSigner(signer) {
        this.signer = signer;
        return this;
    }
    setWaitConfirmations(num) {
        this._waitConfirmations = num;
    }
    balanceOf(owner, config) {
        if (this.provider === undefined || this.erc721 === undefined) {
            return Promise.reject("need to connect a valid provider");
        }
        return this.erc721.balanceOf(owner, { ...config });
    }
    ownerOf(tokenId, config) {
        if (this.provider === undefined || this.erc721 === undefined) {
            return Promise.reject("need to connect a valid provider");
        }
        return this.erc721.ownerOf(tokenId, { ...config });
    }
    name(config) {
        if (this.provider === undefined || this.erc721 === undefined) {
            return Promise.reject("need to connect a valid provider");
        }
        return this.erc721.name({ ...config });
    }
    symbol(config) {
        if (this.provider === undefined || this.erc721 === undefined) {
            return Promise.reject("need to connect a valid provider");
        }
        return this.erc721.symbol({ ...config });
    }
    tokenURI(tokenId, config) {
        if (this.provider === undefined || this.erc721 === undefined) {
            return Promise.reject("need to connect a valid provider");
        }
        return this.erc721.tokenURI(tokenId, { ...config });
    }
    async transferFrom(from, to, tokenId, config) {
        if (this.provider === undefined || this.erc721 === undefined || this.signer === undefined) {
            return Promise.reject("need to connect a valid provider and signer");
        }
        const transaction = await this.erc721
            .connect(this.signer)["safeTransferFrom(address,address,uint256)"](from, to, tokenId, {
            ...config
        });
        const receipt = await transaction.wait(this._waitConfirmations);
        return receipt.transactionHash;
    }
}
exports.EtherERC721Client = EtherERC721Client;
//# sourceMappingURL=EtherERC721Client.js.map